function initMediaGallery() {
    let productmediaWrapper = document.querySelectorAll('.custom-main__product--wrapper');
    productmediaWrapper.forEach(wrapper => {
        let id = wrapper.dataset.sectionId;

        let ThumbnailSliderContainer = wrapper.querySelector('#product-thumbs-' + id);
        let thumbsBtnPrevious = ThumbnailSliderContainer.querySelector('.swiper-button-prev');
        let thumbsBtnNext = ThumbnailSliderContainer.querySelector('.swiper-button-next');

        let MediaSliderContainer = wrapper.querySelector('#product-gallery-' + id);
        let mainBtnPrevious = MediaSliderContainer.querySelector('.swiper-button-prev');
        let mainBtnNext = MediaSliderContainer.querySelector('.swiper-button-next');

        if (ThumbnailSliderContainer) {
            if (ThumbnailSliderContainer.swiper) {
            ThumbnailSliderContainer.swiper.destroy();
            }
            let thumbsSwiperOptions = {
                slidesPerView: 4,
                spaceBetween: 4,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: thumbsBtnNext,
                    prevEl: thumbsBtnPrevious
                },
                breakpoints: {
                    481: {
                        slidesPerView: 5,
                        spaceBetween: 4,
                    },
                    769: {
                        slidesPerView: 6,
                        spaceBetween: 8,
                    },
                },
            }
            swiperThumbs = new Swiper(ThumbnailSliderContainer, thumbsSwiperOptions);
        }
        if (MediaSliderContainer) {
            if (MediaSliderContainer.swiper) {
            MediaSliderContainer.swiper.destroy();
            }
            let mediaSwiperOptions = {
                slidesPerView: 1,
                autoHeight: true,
                navigation: {
                    nextEl: mainBtnNext,
                    prevEl: mainBtnPrevious
                },
                thumbs: {
                    swiper: swiperThumbs
                },
            }
            mediaSwiper[id] = new Swiper(MediaSliderContainer, mediaSwiperOptions);
        }
    });
}
function quantitySelectors() {
    const quantityWrappers = document.querySelectorAll(".custom-product__quantity--selector");

    quantityWrappers.forEach(wrapper => {
        if (wrapper) {
            const input = wrapper.querySelector(".custom-product__quantity--input");
            const plusBtn = wrapper.querySelector(".custom-product__btn--plus");
            const minusBtn = wrapper.querySelector(".custom-product__btn--minus");

            if (!input || !plusBtn || !minusBtn) return;

            plusBtn.addEventListener("click", () => {
                let value = parseInt(input.value) || 1;
                input.value = value + 1;
                input.dispatchEvent(new Event("change"));
            });

            minusBtn.addEventListener("click", () => {
                let value = parseInt(input.value) || 1;
                if (value > 1) {
                    input.value = value - 1;
                    input.dispatchEvent(new Event("change"));
                }
            });

            input.addEventListener("input", () => {
                if (input.value < 1 || input.value === "") {
                    input.value = 1;
                }
            });
        }
        
    });
}
document.addEventListener('DOMContentLoaded', () => {
    initMediaGallery();
    quantitySelectors();
    document.querySelectorAll('.custom-product__accordion-header').forEach(header => {
        if (header) {
            header.addEventListener('click', () => {
                header.parentElement.classList.toggle('active');
            });
        }
        
    });
});


(function () {
  const BTN = '.custom-product__form--cart-btn';
  const prefixes = new WeakMap();

  function priceText(el) {
    if (!el) return '';
    const clone = el.cloneNode(true);
    clone.querySelectorAll('.kaching-bundles__bar-price__unit-label').forEach(n => n.remove());
    return clone.textContent.trim();
  }

  function priceForButton(btn) {
    const form = btn.closest('form');

    if (form) {
      const hid = form.querySelector('input[name="properties[__kaching_bundles]"]');
      if (hid) {
        try {
          const data = JSON.parse(hid.value);
          if (data && data.bar) {
            const bar = document.querySelector('[data-deal-bar-id="' + data.bar + '"]');
            const p = bar ? priceText(bar.querySelector('.kaching-bundles__bar-price')) : '';
            if (p) return p;
          }
        } catch (e) {}
      }
    }

    const r = form || document;
    const sub = r.querySelector('.kaching-bundles__subscriptions [role="checkbox"]');
    if (sub && sub.getAttribute('aria-checked') === 'true') {
      const sp = priceText(r.querySelector('.kaching-bundles__subscriptions .kaching-bundles__bar-price'));
      if (sp) return sp;
    }
    let bar = Array.from(r.querySelectorAll('.kaching-bundles__bar--selected'))
      .find(b => !b.closest('.kaching-bundles__subscriptions'));
    if (bar) { const p = priceText(bar.querySelector('.kaching-bundles__bar-price')); if (p) return p; }
    const checked = r.querySelector('.kaching-bundles__bars input[type="radio"]:checked');
    if (checked) {
      bar = checked.closest('.kaching-bundles__bar');
      if (bar) { const p = priceText(bar.querySelector('.kaching-bundles__bar-price')); if (p) return p; }
    }
    return '';
  }

  function getPrefix(btn) {
    if (prefixes.has(btn)) return prefixes.get(btn);
    const p = btn.textContent.trim().replace(/[\$€£][\d.,]+.*$/, '').trim() + ' ';
    prefixes.set(btn, p);
    return p;
  }

  function enforce() {
    document.querySelectorAll(BTN).forEach(function (btn) {
      const price = priceForButton(btn);
      if (!price) return;
      const desired = getPrefix(btn) + price;
      if (btn.textContent.trim() !== desired.trim()) btn.textContent = desired;
    });
  }

  function scheduleEnforce() {
    enforce();
    setTimeout(enforce, 50);
    setTimeout(enforce, 200);
  }

  function start() {
    document.addEventListener('click', scheduleEnforce, true);
    document.addEventListener('change', scheduleEnforce, true);
    window.addEventListener('load', scheduleEnforce);

    const observer = new MutationObserver(function () {
      observer.disconnect();
      enforce();
      observer.observe(document.body, { childList: true, subtree: true });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    [0, 300, 800, 1500, 2500, 4000].forEach(function (t) { setTimeout(enforce, t); });
    setInterval(enforce, 500);
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();

